import { Directive, OnDestroy, OnInit } from '@angular/core';
import { IonRefresher } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { StayStore } from '../stay.store';

@Directive({
  selector: '[cwtStayRefresher]'
})
export class StayRefresherDirective implements OnInit, OnDestroy {

  private _sub: Subscription;

  constructor(
    protected store: StayStore,
    protected refresher: IonRefresher
  ) { }

  ngOnInit(): void {
    this._sub = this.refresher.ionRefresh.subscribe(() => {
      this.store.refresh()
        .catch(() => this.refresher.complete())
        .then(() => this.refresher.complete());
    });
  }

  ngOnDestroy(): void {
    this._sub?.unsubscribe();
  }
}
